import axios from './api';

export default function getCheckIn() {
    return new Promise((resolve, reject) => {
        axios.get("home/getCheckInDate", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
